//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { v4 as uuidv4 } from 'uuid'
import BlogHead from '~/components/blog/BlogHead.vue'
import PostBanner from '~/components/blog/PostBanner.vue'
import GeneralPost from '~/components/blog/GeneralPost.vue'
// import Newsletter from '~/components/blog/Newsletter.vue'
import APIloading from '~/components/common/APILoading.vue'
import APIFailed from '~/components/common/APIFailed.vue'
import FooterTop from '~/components/footer/footerTop.vue'
import { esaEncryptData, esaDecryptData } from '~/plugins/secret'

export default {
  components: {
    BlogHead,
    PostBanner,
    GeneralPost,
    // Newsletter,
    APIloading,
    APIFailed,
    FooterTop
  },
  data () {
    return {
      categories: [
        '',
        this.$i18n.t('blog.category-1') || 'Company News',
        this.$i18n.t('blog.category-2') || 'Industry News',
        this.$i18n.t('blog.category-3') || 'Product News',
        this.$i18n.t('blog.category-4') || 'Events'
      ],
      ready: false,
      fetched: false,
      fetchError: false,
      posts: [],
      cat1: [],
      cat2: [],
      cat3: [],
      cat4: [],
      currentLocale: null,
      categoryHeights: [null, null, null, null, null],
      categoryIntervals: [null, null, null, null, null],
      categoryShowBtn: [true, true, true, true, true],
      resizeObserver: null
    }
  },
  async fetch () {
    if (!this.$encrypt) {
      return
    }
    try {
      const uuid = uuidv4().replace(/-/g, '')
      const blogResponse = await fetch(
        `${process.env.APIURL}/website/common/blog/list`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            key: this.$encrypt(uuid),
            data: esaEncryptData(
              JSON.stringify({
                date_mode: '', // 检索的时间类型 1.创建时间 2.更新时间
                start_time: '', // 开始时间 string
                end_time: '' // 结束时间 string
              }),
              uuid
            )
          })
        }
      )
        .then(res => res.json())
        .catch(function (e) {})
      const { data, key } = blogResponse
      const preResult = esaDecryptData(data, this.$decrypt(key))
      const posts = JSON.parse(preResult).list
      // eslint-disable-next-line no-console
      // console.log('posts ===>', posts)
      if (posts.length) {
        const locale = this.$i18n.locale
        this.currentLocale = locale
        let filteredPosts = []
        if (locale === 'en') {
          filteredPosts = posts.filter(post => (post.lang_id === 'en' && Number(post.status) === 1 && Number(post.logical_status) === 1)) || []
        } else if (locale === 'pt') {
          filteredPosts = posts.filter(post => (post.lang_id === 'pt' && Number(post.status) === 1 && Number(post.logical_status) === 1)) || []
        } else if (locale === 'zh') {
          filteredPosts = posts.filter(post => (post.lang_id === 'zh' && Number(post.status) === 1 && Number(post.logical_status) === 1)) || []
        } else if (locale === 'es') {
          filteredPosts = posts.filter(post => (post.lang_id === 'es' && Number(post.status) === 1 && Number(post.logical_status) === 1)) || []
        }
        if (filteredPosts.length) {
          this.posts = filteredPosts
          this.fetched = true
          return
        } else {
          filteredPosts = posts.filter(post => (post.lang_id === 'pt' && Number(post.status) === 1 && Number(post.logical_status) === 1)) || []
          if (filteredPosts.length) {
            this.posts = filteredPosts
            this.fetched = true
            return
          }
        }
      }
      this.fetched = true
      this.posts = []
    } catch (err) {
      console.log('err', err)
      this.posts = []
      this.fetched = true
      // this.fetchError = true
    }
  },
  // fetchOnServer: false,
  head () {
    return {
      title: this.$t('footer.about.blog').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  },
  watch: {
    posts (val, oldVal) {
      if (val.length && val !== oldVal) {
        this.cat1 = this.getPosts(0, 1000, { active: true, catName: 1 })
        this.cat2 = this.getPosts(0, 1000, { active: true, catName: 2 })
        this.cat3 = this.getPosts(0, 1000, { active: true, catName: 3 })
        this.cat4 = this.getPosts(0, 1000, { active: true, catName: 4 })
      } else {
        this.cat1 = []
        this.cat2 = []
        this.cat3 = []
        this.cat4 = []
      }
      this.observeHeight()
    }
  },
  mounted () {
    this.ready = true
    this.$nuxt.$emit('currentPage', 'blog')
    this.clientFetch()
  },
  beforeUpdate () {
    if (this.currentLocale !== this.$i18n.locale) {
      this.currentLocale = this.$i18n.locale
      this.clientFetch()
    }
  },
  beforeDestroy () {
    this.$nuxt.$emit('currentPage', '')
  },
  methods: {
    showContent (category) {
      if (typeof category === 'number') {
        const categorySBtn = this.categoryShowBtn
        categorySBtn[category] = false
        this.categoryShowBtn = [...categorySBtn]
      }
    },
    getPosts (start, end, category) {
      const { active, catName } = category || {}
      let posts = []
      if (active) {
        posts = this.posts.filter(post => Number(post.class_id) === catName)
      } else {
        posts = this.posts || []
      }
      // console.log('posts', posts)
      if (posts !== null && posts.length) {
        return posts.slice(start, end)
      }
      return []
    },
    observeHeight () {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect()
      }
      this.resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          if (
            entry &&
            entry.target &&
            entry.target.hasAttribute('data-category')
          ) {
            const parent = entry.target.parentNode || null
            const parentHeight = parent.offsetHeight || null
            const elementHeight = entry.target.offsetHeight || null
            const currentCategory =
              entry.target.getAttribute('data-category') || null
            if (parentHeight && elementHeight) {
              let haveFewPosts = false
              const nElements = document.querySelectorAll(
                `.post-by-category[data-category='${currentCategory}'] > a.general-post`
              ).length
              if (nElements <= 3) {
                const categorySBtn = this.categoryShowBtn
                categorySBtn[Number(currentCategory)] = false
                this.categoryShowBtn = [...categorySBtn]
                haveFewPosts = true
              }
              if (
                (this.categoryShowBtn[Number(currentCategory)] &&
                  !haveFewPosts) ||
                (this.categoryShowBtn[Number(currentCategory)] &&
                  parentHeight < elementHeight + elementHeight / 2)
              ) {
                this.changeCategoriesHeight({
                  category: currentCategory,
                  height: elementHeight,
                  parent
                })
              } else if (this.categoryShowBtn[Number(currentCategory)]) {
                const categorySBtn = this.categoryShowBtn
                categorySBtn[Number(currentCategory)] = false
                this.categoryShowBtn = [...categorySBtn]
              }
            }
          }
        }
      })
      setTimeout(() => {
        const elements = document.querySelectorAll(
          '.post-by-category > a.general-post:first-of-type'
        )
        elements.forEach((element) => {
          this.resizeObserver.observe(element)
        })
      }, 1000)
    },
    changeCategoriesHeight (params) {
      const { height, category, parent } = params
      if (height && category && parent) {
        if (this.categoryIntervals[Number(category)]) {
          clearTimeout(this.categoryIntervals[Number(category)])
        }
        this.categoryIntervals = setTimeout(() => {
          const categoryHs = this.categoryHeights
          categoryHs[Number(category)] = `${height}px`
          this.categoryHeights = [...categoryHs]
        }, 1000)
      }
    },
    clientFetch () {
      this.$fetch()
    }
  }
}
